import store from '@/store';

import guardUtils from '@/portal/guards/guard-utils';

const isAuthenticated = {
  check: async (to) => {
    let user;
    try {
      const { hasAuthToken } = store.getters;
      user = hasAuthToken ? await guardUtils.fetchUser() : null;
    } catch {
      // Do nothing
    }

    if (!user) {
      const {
        client_uuid: clientUuid,
        location_uuid: locationUuid,
      } = to.query;
      const redirectPath = to.meta.redirectPath || (clientUuid && locationUuid ? 'signup' : 'login');
      const redirectUrl = encodeURIComponent(window.location.href);
      const { authRedirectUrl } = store.state.config;
      const resolvedUrl = `${authRedirectUrl}/${redirectPath}?redirect_to=${redirectUrl}`;
      window.open(resolvedUrl, '_self');
      // Delay the completion of the guard for 2 seconds to allow the redirect to finish.
      return new Promise((resolve, reject) => setTimeout(reject, 2000));
    }
    return true;
  },
};

export default {
  isAuthenticated,
};
